"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _reactSpinnersCss = require("react-spinners-css");

var _reactVerificationCodeInput = _interopRequireDefault(require("react-verification-code-input"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _awsAmplify = _interopRequireWildcard(require("aws-amplify"));

var _reactBootstrap = require("react-bootstrap");

var _syngentaReactComponents = require("syngenta-react-components");

var _hooksLib = require("../../libs/hooksLib");

var _formatHelper = require("../../libs/formatHelper");

require("./Login.css");

var _index = _interopRequireDefault(require("../Modal/index"));

var _index2 = _interopRequireDefault(require("../Button/index"));

var _visibility = _interopRequireDefault(require("../../asset/icons/visibility.svg"));

var _visibility_off = _interopRequireDefault(require("../../asset/icons/visibility_off.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _readOnlyError(name) { throw new Error("\"" + name + "\" is read-only"); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var initialState = {
  method: 'Unknown error has occured, please try again',
  showContact: true
};

var _getHashValue = function _getHashValue(key) {
  var matches = location.hash.match(new RegExp(key + '=([^&]*)'));
  return matches ? matches[1] : null;
};

function reducer(state, action) {
  switch (action.type) {
    case 'email_error':
      return {
        textDisplay: "Invalid username or password code combination, please try again",
        showContact: true
      };

    case 'phone_error':
      return {
        textDisplay: "Invalid phone or sms code combination, please try again",
        showContact: true
      };

    case 'incomplete_login':
      return {
        textDisplay: 'Please provide a valid email or 10 digit phone number',
        showContact: false
      };

    case 'sms_resend':
      return {
        textDisplay: 'New SMS code sent',
        showContact: false
      };

    default:
      throw new Error();
  }
}

var Login = function Login(_ref) {
  var APP_CLIENT_ID = _ref.APP_CLIENT_ID,
      COGNITO_DOMAIN = _ref.COGNITO_DOMAIN,
      COGNITO_SIGNIN_CALLBACK = _ref.COGNITO_SIGNIN_CALLBACK,
      COGNITO_SIGNOUT_CALLBACK = _ref.COGNITO_SIGNOUT_CALLBACK,
      containerClasses = _ref.containerClasses,
      forgotPasswordPath = _ref.forgotPasswordPath,
      errorContact = _ref.errorContact,
      facebookLogin = _ref.facebookLogin,
      propsIsLoading = _ref.propsIsLoading,
      googleLogin = _ref.googleLogin,
      handler = _ref.handler,
      IDENTITY_POOL_ID = _ref.IDENTITY_POOL_ID,
      logoPath = _ref.logoPath,
      REGION = _ref.REGION,
      API_URL = _ref.API_URL,
      STAGE = _ref.STAGE,
      USER_POOL_ID = _ref.USER_POOL_ID,
      allowSignup = _ref.allowSignup,
      responseType = _ref.responseType,
      scope = _ref.scope;

  var _useState = (0, _react.useState)(propsIsLoading || false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useFormFields = (0, _hooksLib.useFormFields)({
    phoneOrEmail: '',
    password: ''
  }),
      _useFormFields2 = _slicedToArray(_useFormFields, 2),
      fields = _useFormFields2[0],
      handleFieldChange = _useFormFields2[1];

  var _useState3 = (0, _react.useState)('init'),
      _useState4 = _slicedToArray(_useState3, 2),
      view = _useState4[0],
      setView = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      session = _useState6[0],
      setSession = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      rememberMe = _useState8[0],
      setRememberMe = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showModal = _useState10[0],
      setShowModal = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      user = _useState12[0],
      setUser = _useState12[1];

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      showPassword = _useState14[0],
      setShowPassword = _useState14[1];

  _awsAmplify["default"].configure({
    Auth: {
      mandatorySignIn: true,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
      region: REGION,
      userPoolId: USER_POOL_ID,
      identityPoolId: IDENTITY_POOL_ID,
      userPoolWebClientId: APP_CLIENT_ID,
      oauth: {
        domain: COGNITO_DOMAIN,
        scope: scope ? scope : ['phone', 'email', 'profile', 'openid'],
        redirectSignIn: COGNITO_SIGNIN_CALLBACK,
        redirectSignOut: COGNITO_SIGNOUT_CALLBACK,
        responseType: responseType || 'code'
      }
    }
  });

  (0, _react.useEffect)(function () {
    var useEffectFn = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var sso_federated_error_check;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sso_federated_error_check = _getHashValue('error_description');
                if (propsIsLoading) setIsLoading(true);

                if (sso_federated_error_check) {
                  handler({
                    error: sso_federated_error_check.replace(/\+/g, ' ')
                  });
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function useEffectFn() {
        return _ref2.apply(this, arguments);
      };
    }();

    useEffectFn();
  }, []);

  var modalHandler = function modalHandler(type) {
    setShowModal(true);
    dispatch({
      type: type
    });
  };

  var className = 'Login';
  if (containerClasses) className += " ".concat(containerClasses);

  function validateForm() {
    return fields.phoneOrEmail.length > 0;
  }

  var defaultHandler = function defaultHandler() {
    return alert('No handler passed, this is a default alert indicating login was successful.');
  };

  var handleLogin = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(event, smsCode) {
      var bypassUserCheck, _user, result, _rememberMe, accessToken, _accessToken;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (event) event.preventDefault();
              setIsLoading(true);
              localStorage.removeItem('accessToken');
              window.sessionStorage.removeItem('accessToken');
              bypassUserCheck = false;
              _context2.prev = 5;
              _user = null;

              if (!(view === 'sms')) {
                _context2.next = 15;
                break;
              }

              if (!user) {
                _context2.next = 13;
                break;
              }

              _context2.next = 11;
              return _awsAmplify.Auth.sendCustomChallengeAnswer(user, smsCode);

            case 11:
              result = _context2.sent;

              if (result && result.signInUserSession && result.signInUserSession.accessToken) {
                _rememberMe = localStorage.getItem('rememberMe');
                localStorage.removeItem('accessToken');
                localStorage.removeItem('rememberMe');
                accessToken = result.signInUserSession.accessToken.jwtToken;

                if (_rememberMe === 'true') {
                  localStorage.setItem('accessToken', accessToken);
                } else {
                  window.sessionStorage.setItem('accessToken', accessToken);
                }

                setIsLoading(false);
                handler({
                  error: null,
                  accessToken: accessToken
                });
              } else {
                setIsLoading(false);
                setView('init');
                modalHandler('phone_error');
              }

            case 13:
              _context2.next = 23;
              break;

            case 15:
              if (!(view === 'password')) {
                _context2.next = 22;
                break;
              }

              _context2.next = 18;
              return _awsAmplify.Auth.signIn(fields.phoneOrEmail, fields.password);

            case 18:
              _user = _context2.sent;

              if (!_user) {
                modalHandler('email_error');
                bypassUserCheck = (_readOnlyError("bypassUserCheck"), true);
              }

              _context2.next = 23;
              break;

            case 22:
              return _context2.abrupt("return");

            case 23:
              if (_user && !bypassUserCheck) {
                _accessToken = _user.pool.storage["".concat(_user.keyPrefix, ".").concat(_user.attributes.email, ".accessToken")];
                window.sessionStorage.setItem('accessToken', _accessToken);
                setIsLoading(false);
                handler ? handler({
                  error: null,
                  user: _user
                }) : defaultHandler();
              }

              _context2.next = 31;
              break;

            case 26:
              _context2.prev = 26;
              _context2.t0 = _context2["catch"](5);
              handler({
                error: _context2.t0.message,
                user: null
              });
              setIsLoading(false);
              modalHandler('email_error');

            case 31:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[5, 26]]);
    }));

    return function handleLogin(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleNext = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(event) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              event.preventDefault();
              localStorage.removeItem('user_email');
              localStorage.removeItem('user_phone');
              setIsLoading(true);

              if (!(0, _formatHelper.isValidSyngentaEmail)(fields.phoneOrEmail)) {
                _context3.next = 9;
                break;
              }

              localStorage.setItem('user_email', fields.phoneOrEmail);
              handleSSO(event, 'SyngentaSSO');
              _context3.next = 21;
              break;

            case 9:
              if (!(0, _formatHelper.isValidEmail)(fields.phoneOrEmail)) {
                _context3.next = 14;
                break;
              }

              localStorage.setItem('user_email', fields.phoneOrEmail);
              setView('password');
              _context3.next = 21;
              break;

            case 14:
              if (!(0, _formatHelper.isValidPhoneNumber)(fields.phoneOrEmail)) {
                _context3.next = 20;
                break;
              }

              localStorage.setItem('user_phone', fields.phoneOrEmail);
              _context3.next = 18;
              return sendSMSHandler();

            case 18:
              _context3.next = 21;
              break;

            case 20:
              modalHandler('incomplete_login');

            case 21:
              setIsLoading(false);

            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleNext(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var initiateAuthFlow = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(phoneOrEmail) {
      var key, response;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              key = (0, _formatHelper.isValidEmail)(fields.phoneOrEmail) ? 'email' : 'phone';
              _context4.next = 4;
              return _axios["default"].get("".concat(API_URL, "/platform-users-auth/v1/initiate-auth?").concat(key, "=").concat(phoneOrEmail, "&client_id=").concat(APP_CLIENT_ID, "&user_pool_id=").concat(USER_POOL_ID));

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              Promise.resolve(null);
              console.error('error: ', _context4.t0);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 8]]);
    }));

    return function initiateAuthFlow(_x4) {
      return _ref5.apply(this, arguments);
    };
  }();

  var generate_random_password = function generate_random_password() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var addUpper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var addNumbers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var addSymbols = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var lowerCharacters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    var upperCharacters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    var symbols = ['!', '?', '@'];

    var getRandom = function getRandom(array) {
      return array[Math.floor(Math.random() * array.length)];
    };

    var finalCharacters = '';

    if (addUpper) {
      finalCharacters = finalCharacters.concat(getRandom(upperCharacters));
    }

    if (addNumbers) {
      finalCharacters = finalCharacters.concat(getRandom(numbers));
    }

    if (addSymbols) {
      finalCharacters = finalCharacters.concat(getRandom(symbols));
    }

    for (var i = 1; i < length - 3; i++) {
      finalCharacters = finalCharacters.concat(getRandom(lowerCharacters));
    }

    return finalCharacters.split('').sort(function () {
      return 0.5 - Math.random();
    }).join('');
  };

  var sendSMSHandler = function sendSMSHandler(resend) {
    return new Promise( /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(resolve) {
        var _session2;

        var phoneOrEmail, _session, check, email, temp_password, auth_obj, _newUser, _session3, _session4, _user, _session5, _user2;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                phoneOrEmail = fields.phoneOrEmail;
                _context5.next = 3;
                return initiateAuthFlow(phoneOrEmail);

              case 3:
                _session = _context5.sent;

                if (!((_session2 = _session) === null || _session2 === void 0 ? void 0 : _session2.session)) {
                  _context5.next = 36;
                  break;
                }

                check = _session.session.substr(_session.session.length - 4);
                setSession(_session.session);

                if (!(check === '-un4' && allowSignup)) {
                  _context5.next = 27;
                  break;
                }

                email = phoneOrEmail.indexOf('@') > -1 ? phoneOrEmail : "".concat(phoneOrEmail, "@syndpe.com");
                temp_password = generate_random_password();
                auth_obj = {
                  username: email,
                  password: temp_password
                };
                if (phoneOrEmail != email) auth_obj['attributes'] = {
                  phone_number: "+1".concat(phoneOrEmail)
                };
                _context5.next = 14;
                return _awsAmplify.Auth.signUp(auth_obj);

              case 14:
                _newUser = _context5.sent;

                if (!(_newUser.user.username && phoneOrEmail != email)) {
                  _context5.next = 25;
                  break;
                }

                _context5.next = 18;
                return initiateAuthFlow(phoneOrEmail);

              case 18:
                _session = _context5.sent;

                if (!((_session3 = _session) === null || _session3 === void 0 ? void 0 : _session3.username)) {
                  _context5.next = 24;
                  break;
                }

                _context5.next = 22;
                return _awsAmplify.Auth.signIn(_session.username);

              case 22:
                _user = _context5.sent;
                setUser(_user);

              case 24:
                if ((_session4 = _session) === null || _session4 === void 0 ? void 0 : _session4.session) {
                  setSession(_session.session);
                  setView('sms');
                } else {
                  modalHandler('phone_error');
                  setView('init');
                }

              case 25:
                _context5.next = 33;
                break;

              case 27:
                if (!((_session5 = _session) === null || _session5 === void 0 ? void 0 : _session5.username)) {
                  _context5.next = 32;
                  break;
                }

                _context5.next = 30;
                return _awsAmplify.Auth.signIn(_session.username);

              case 30:
                _user2 = _context5.sent;
                setUser(_user2);

              case 32:
                setView('sms');

              case 33:
                if (resend) {
                  modalHandler('sms_resend');
                }

                _context5.next = 38;
                break;

              case 36:
                modalHandler('phone_error');
                setView('init');

              case 38:
                resolve();

              case 39:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x5) {
        return _ref6.apply(this, arguments);
      };
    }());
  };

  function handleSSO(_x6, _x7) {
    return _handleSSO.apply(this, arguments);
  }

  function _handleSSO() {
    _handleSSO = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(event, provider) {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              event.preventDefault();
              localStorage.setItem('rememberMe', rememberMe ? true : false);
              _context6.next = 4;
              return _awsAmplify.Auth.federatedSignIn({
                provider: provider
              });

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return _handleSSO.apply(this, arguments);
  }

  var renderSSO = function renderSSO() {
    if (googleLogin || facebookLogin) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "w100%"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "bb1-s-lightgray mt50"
      }), googleLogin && /*#__PURE__*/_react["default"].createElement(_syngentaReactComponents.LoaderButton, {
        customClassName: "custom-button google-red w320 mt15",
        clickHandler: function clickHandler(e) {
          return handleSSO(e, 'Google');
        }
      }, "Continue with\xA0", /*#__PURE__*/_react["default"].createElement("i", {
        className: "fa fa-google",
        "aria-hidden": "true"
      })), facebookLogin && /*#__PURE__*/_react["default"].createElement("div", {
        className: "w100%"
      }, /*#__PURE__*/_react["default"].createElement(_syngentaReactComponents.LoaderButton, {
        customClassName: "custom-button facebook-blue w320 mt15",
        clickHandler: function clickHandler(e) {
          return handleSSO(e, 'Facebook');
        }
      }, "Continue with\xA0", /*#__PURE__*/_react["default"].createElement("i", {
        className: "fa fa-facebook w345",
        "aria-hidden": "true"
      }))));
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb75"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: logoPath,
    alt: "company logo"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "fw600 fz17 df mb20"
  }, view !== 'sms' ? /*#__PURE__*/_react["default"].createElement("span", null, "Login") : /*#__PURE__*/_react["default"].createElement("span", null, "We Sent A Code To Your Phone")), /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleLogin
  }, view === 'init' && /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, {
    controlId: "phoneOrEmail",
    bsSize: "large"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.ControlLabel, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "df fz15"
  }, "Email/Phone")), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormControl, {
    type: "text",
    placeholder: "Enter Email or Phone Number",
    value: fields.phoneOrEmail,
    onChange: handleFieldChange,
    onKeyDown: function onKeyDown(e) {
      return (0, _formatHelper.preventWhiteSpace)(e);
    }
  })), view === 'password' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, {
    className: "posr",
    controlId: "password",
    bsSize: "large"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.ControlLabel, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "df fz15"
  }, "Password")), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormControl, {
    type: showPassword ? 'text' : 'password',
    value: fields.password,
    onChange: handleFieldChange,
    onKeyDown: function onKeyDown(e) {
      return (0, _formatHelper.preventWhiteSpace)(e);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "posa curp rperc5 t32",
    onClick: function onClick() {
      setShowPassword(!showPassword);
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: showPassword ? _visibility_off["default"] : _visibility["default"]
  })))), view === 'sms' && /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, {
    controlId: "sms",
    bsSize: "large"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.ControlLabel, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "df fz15"
  }, "Enter the 6 Digit Code Here")), /*#__PURE__*/_react["default"].createElement(_reactVerificationCodeInput["default"], {
    ref: fields.sms,
    className: "custom-class",
    onChange: handleFieldChange,
    onComplete: function onComplete(val) {
      return handleLogin(null, val);
    },
    fieldWidth: 50,
    fieldHeight: 46,
    autoFocus: true,
    loading: isLoading
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w100% mt35 mb15 ".concat(view === 'sms' ? 'dn' : '')
  }, /*#__PURE__*/_react["default"].createElement(_syngentaReactComponents.LoaderButton, {
    customClassName: "custom-button syngenta-green w320 mt15",
    clickHandler: view !== 'init' ? handleLogin : handleNext,
    disabled: !validateForm() || isLoading
  }, view !== 'init' ? /*#__PURE__*/_react["default"].createElement("div", null, isLoading ? /*#__PURE__*/_react["default"].createElement(_reactSpinnersCss.Ring, {
    color: "white",
    size: 20
  }) : 'Login') : /*#__PURE__*/_react["default"].createElement("div", null, isLoading ? /*#__PURE__*/_react["default"].createElement(_reactSpinnersCss.Ring, {
    color: "white",
    size: 20
  }) : 'Next'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "df fxdrc tal curp"
  }, view !== 'init' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "tdn c-green",
    onClick: function onClick() {
      setView('init');
    }
  }, "Go Back"), forgotPasswordPath && /*#__PURE__*/_react["default"].createElement("div", {
    className: "tdn c-green",
    onClick: function onClick() {
      window.location = forgotPasswordPath;
    }
  }, "Forgot Password"), view === 'sms' && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "c-green curp",
    onClick: function onClick() {
      return sendSMSHandler(true);
    }
  }, "Resend SMS"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "c-green curp",
    onClick: function onClick() {
      setView('init');
    }
  }, "Cancel"))), view === 'password' && renderSSO()), /*#__PURE__*/_react["default"].createElement(_index["default"], {
    customClassName: "p25",
    handleClose: function handleClose() {
      setShowModal(false);
    },
    show: showModal
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, state.textDisplay), state.showContact && errorContact && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt20 mb20"
  }, "If you think this was an error please contact ".concat(errorContact)), /*#__PURE__*/_react["default"].createElement(_index2["default"], {
    type: "success",
    customClassName: "mt20",
    clickHandler: function clickHandler() {
      return setShowModal(false);
    },
    text: "Close"
  }))));
};

Login.propTypes = {
  APP_CLIENT_ID: _propTypes["default"].string.isRequired,
  COGNITO_DOMAIN: _propTypes["default"].string.isRequired,
  COGNITO_SIGNIN_CALLBACK: _propTypes["default"].string.isRequired,
  COGNITO_SIGNOUT_CALLBACK: _propTypes["default"].string.isRequired,
  containerClasses: _propTypes["default"].string,
  errorContact: _propTypes["default"].string,
  facebookLogin: _propTypes["default"].bool,
  googleLogin: _propTypes["default"].bool,
  handler: _propTypes["default"].func.isRequired,
  IDENTITY_POOL_ID: _propTypes["default"].string.isRequired,
  logoPath: _propTypes["default"].string,
  forgotPasswordPath: _propTypes["default"].string,
  REGION: _propTypes["default"].string.isRequired,
  SSOLogin: _propTypes["default"].bool,
  API_URL: _propTypes["default"].string.isRequired,
  STAGE: _propTypes["default"].string.isRequired,
  USER_POOL_ID: _propTypes["default"].string.isRequired
};
var _default = Login;
exports["default"] = _default;